import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { Button } from "@components/buttons";
import { Link } from "react-router-dom";
import { getCurrentCulture } from "@utils";
import { useFormContext } from "react-hook-form";
import {
	RegistrationCity,
	RegistrationHouseNumber,
	RegistrationPOB,
	RegistrationStreet,
	RegistrationZIPCode,
} from "@features/membership/desktop/registration-types/registration";
import { usePartnerRegistrationStore } from "@state/context/membership/registration-types/PartnerRegistrationStoreContext";
import {
	PartnerRegistrationNationality,
	PartnerRegistrationLanguage,
	PartnerRegistrationMonthlyLimit,
	PartnerRegistrationPromotion,
	PartnerRegistrationConditions,
} from "@features/membership/desktop/registration-types/partner-registration";

export const PartnerRegistrationContactDetails = observer(
	function PartnerRegistrationContractDetails() {
		const {
			formState: { isSubmitting },
		} = useFormContext();

		const { t } = useTranslation("registration");

		const { previousStep, countryData, languageData, gamingLimitsData } =
			usePartnerRegistrationStore();

		useEffect(() => {
			//on mount scroll to top
			document.querySelector("html, body")?.scrollTo(0, 0);
		}, []);
		return (
			<>
				<div className="card--onboarding__content">
					<RegistrationStreet labelClassName="label--strong" />

					<RegistrationHouseNumber labelClassName="label--strong" />

					<div className="form__field form--grid">
						<div className="form--grid__row row">
							<div className="form--grid__col col col-sml-3">
								<RegistrationZIPCode labelClassName="label--strong" />
							</div>
							<div className="form--grid__col col col-sml-9">
								<RegistrationCity labelClassName="label--strong" />
							</div>
						</div>
					</div>

					<PartnerRegistrationNationality
						countryData={countryData}
						labelClassName="label--strong"
					/>

					<RegistrationPOB labelClassName="label--strong" />

					<PartnerRegistrationMonthlyLimit
						gamingLimitsData={gamingLimitsData}
						labelClassName="label--strong"
					/>

					<PartnerRegistrationLanguage
						languageData={languageData}
						labelClassName="label--strong"
					/>

					<PartnerRegistrationPromotion />

					<PartnerRegistrationConditions />
				</div>

				<div className="form__field row">
					<div className="col col-sml-6">
						<Button
							type="button"
							atClassName="regAccountBtnPrev"
							className="btn--base btn--block btn--primary--inverted"
							iconLeft
							iconClassName="u-icon--tny u-icon--arrow-left"
							btnText={t("COMMON.PREVIOUS_BUTTON")}
							onClick={previousStep}
						/>
					</div>
					<div className="col col-sml-6">
						<Button
							disabled={isSubmitting}
							atClassName="regAccountBtnNext"
							className="btn--base btn--block btn--accent"
							btnContent={<>{t<string>("OPEN_ACCOUNT")} *</>}
						/>
					</div>
				</div>

				<div className="card--onboarding__footer u-type--sml u-color--text--secondary">
					{t("EXISTING_ACCOUNT")}
					<Link
						to={`/${getCurrentCulture()}/auth/login`}
						className="u-anchor u-anchor--primary u-mar--left--xtny"
					>
						{t("COMMON.LOGIN_BUTTON")}
					</Link>
				</div>
			</>
		);
	}
);
